import { FC, useState } from "react";
import { useFormik } from "formik";
import { Paper } from "@mantine/core";
import { FORM_IDS } from "pages/User/config";
import { userApi } from "apis";
import { useNotification } from "utils/hooks";
import { ErrorStatusType } from "constants/types/common";
import UserFormFields from "../UserFormFields/UserFormFields";
import { PasswordResetBodyType, UserResponse } from "constants/types/user";
import * as yup from "yup";
import { Loading } from "components";

type Props = {
  user?: UserResponse;
  onClose?: () => void;
  mutate?: any;
};

const resetPasswordValicationSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, "Mật khẩu phải có ít nhất 8 ký tự")
    .matches(/[A-Z]/, "Mật khẩu phải chứa ít nhất 1 chữ hoa")
    .matches(/[\W_]/, "Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt")
    .required("Vui lòng nhập mật khẩu"),
});

const ResetPasswordForm: FC<Props> = ({ user, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: resetPasswordValicationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!user?.id) {
        notification.error({ title: "Không tìm thấy ID người dùng" });
        return;
      }

      setIsLoading(true);

      try {
        // Only send phone and roles for update
        const updateData: PasswordResetBodyType = {
          password: values.password,
        };

        const _res = await userApi.resetPassword(user.id, updateData);

        if (_res.data.success) {
          notification.success({ title: "Đặt lại mật khẩu thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Đặt lại mật khẩu thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.RESET_PASSWORD} onSubmit={formik.handleSubmit}>
          <UserFormFields
            formik={formik}
            isCreateMode={false}
            isPasswordReset={true}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default ResetPasswordForm;
